<template>
    <div class="scope-more-entrance">
        <el-row class="text-center">
            <el-col :span="6" v-for="(item, index) in subMenu" :key="index">
                <router-link :to="{name: item.value}">
                    <div class="item-entrance">
                        <i class="item-entrance-tag" :class="iconMap[item.value]"></i>
                        <span class="item-entrance-title">{{ item.text }}</span>
                    </div>
                </router-link>
            </el-col>
        </el-row>
    </div>
</template>
<script type="text/javascript">
    export default {
        data () {
            return {
                iconMap: {
                    boleList: 'tag-bole'
                }
            }
        },
        computed: {
            subMenu () {
                let menu = this.$store.state.app.menu,
                    sub = menu[menu.length - 1].list
                // sub.push({text: '伯乐管理', value: 'boleList'})
                return sub
            }
        }
    }
</script>
<style type="text/css" lang="scss">
    @import "~variable";
    @import "~style/base/mixin";

    .scope-more-entrance {
        .item-entrance {
            border        : 2px solid transparent;
            padding       : 15px;
            background    : $background-color;
            border-radius : $border-radius;
            box-sizing    : border-box;
            display       : inline-block;
            width         : 360px;
            box-shadow    : 0 0 6px rgba(0, 0, 0, 0.1);
            @include transition;

            &:hover {
                cursor       : pointer;
                border-color : $color-primary;
                .item-entrance-title {
                    color : #000;
                }
            }
            $length : 56px;
            &-tag {
                float      : left;
                width      : $length;
                height     : $length;
                background : url(~images/more/item-tag.png) no-repeat center 0;
                &.tag-project {
                    background-position-y : -$length - 20;
                }
                &.tag-bole {
                    background-position-y : -3 * ($length + 20);
                }
            }
            &-title {
                padding-left   : $length + 20;
                display        : block;
                line-height    : $length;
                vertical-align : middle;
                font-size      : 16px;
                font-weight    : bold;
                color          : $text-color-third;
                text-align     : left;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// entrance.vue?c82d14f6